import { InterstateDealSummarySections, ShowWithFeatureToggle, useDealSummary } from '@makemydeal/dr-dash-components';
import { List } from '@interstate/components/List';

const Cash: React.FC = () => {
    const { showDetailedView } = useDealSummary();

    return (
        <>
            <List data-testid="cash-deal-summary">
                <InterstateDealSummarySections.InterstateMSRP />
                <InterstateDealSummarySections.InterstateDiscount />
                <InterstateDealSummarySections.InterstateDealerDiscounts />
                <InterstateDealSummarySections.InterstateSellingPrice />
                <InterstateDealSummarySections.InterstateAddons />
                <InterstateDealSummarySections.InterstateTotalTax />
                <InterstateDealSummarySections.InterstateNetSellingPrice />
                <InterstateDealSummarySections.InterstateNetTrade />
                <InterstateDealSummarySections.InterstateRebates />
                <ShowWithFeatureToggle name="enableCashDownPaymentField">
                    <InterstateDealSummarySections.InterstateCashDown />
                </ShowWithFeatureToggle>
                <InterstateDealSummarySections.InterstateTotalAmountDue logCashBreakdown />
                <InterstateDealSummarySections.InterstateTotalOfPayments />
                <InterstateDealSummarySections.InterstateTrades />
                {showDetailedView && <InterstateDealSummarySections.InterstateDealPulse />}
            </List>
            {!showDetailedView && <InterstateDealSummarySections.InterstateDealPulse />}
        </>
    );
};

export default Cash;
